import { NgTemplateOutlet } from '@angular/common';
import { Component, input } from '@angular/core';
import { PartnerLogo } from './models/partner-logo-grid/partner-logo.interface';

@Component({
  selector: 'app-partner-logo-grid',
  templateUrl: './partner-logo-grid.component.html',
  styleUrl: './partner-logo-grid.component.scss',
  imports: [NgTemplateOutlet],
})
export class PartnerLogoGridComponent {
  columns = input<number>();
  highlightedPartners = input<PartnerLogo[]>([
    {
      image: {
        alt: 'hoover',
        src: 'assets/gb/hoover/logo.svg',
      },
    },
    {
      image: {
        alt: 'bosch',
        src: 'assets/gb/bosch/logo.svg',
      },
    },
    {
      image: {
        alt: 'zanussi',
        src: 'assets/gb/zanussi/logo.svg',
      },
    },
    {
      image: {
        alt: 'candy',
        src: 'assets/gb/candy/logo.svg',
      },
    },
    {
      image: {
        alt: 'hotpoint',
        src: 'assets/gb/hotpoint/logo.svg',
      },
    },
    {
      image: {
        alt: 'beko',
        src: 'assets/gb/beko/logo.svg',
      },
    },
    {
      image: {
        alt: 'whirlpool',
        src: 'assets/gb/whirlpool/logo.svg',
      },
    },
    {
      image: {
        alt: 'indesit',
        src: 'assets/gb/indesit/logo.svg',
      },
    },
  ]);
}
